




















import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component({ name: "confirm-dialog" })
export default class ConfirmDialog extends Vue {
  /* Constants */

  @Prop({ required: true }) readonly value!: string;

  /* Variables */
  /* Computed */
  /* Methods */

  ok(): void {
    this.$emit("ok");
    this.close();
  }

  @Emit("input")
  close(): null {
    return null;
  }

  /* Life-cycle Methods */
}
